import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/accounts/$accountId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/accounts/$accountId/dashboard',
      params: { accountId: params.accountId },
    })
  },
})
